// @ts-nocheck
import { useEffect, useState } from 'react';
// material
import {
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
  TextField,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Modal,
  Select,
  Tooltip,
  MenuItem,
  FormControl,
  Box,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { Formik } from 'formik';
import ClearIcon from '@mui/icons-material/Clear';
// components
import Page from '../components/Page';
import { useGetRevenueDataMutation } from '../store/api/revenueApi';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';
import {
  capitalName,
  formatDateTime,
  onlyLastEmailShow,
  onlyLastFourNum,
} from '../sections/@dashboard/parkingspaces/utility';
import Loading from '../components/Loading';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import HomeIcon from '@mui/icons-material/Home';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { getAuthDetails } from '../store/state/authSlice';
import {
  useFindMiscellaneousChargeByIdMutation,
  useFindMiscellaneousChargesByBookingIdMutation,
  useSaveMiscellaneousChargeMutation,
  useFindMiscellaneousChargesByLabourIdMutation,
  useGetMiscellaneousByLabourAndBookingMutation,
  useUpdateMiscellaneousChargeMutation,
  useDeleteMiscellaneousChargeMutation,
} from '../store/api/miscellaneousApi';
import { useCalculateBillingRateMutation, useCalculateExtraBillingMutation } from '../store/api/calculateBillingRateApi';
import {
  useGetAllBookingDetailBySearchCriteriaMutation,
  useUpdateBookingDetailMutation,
  useCompleteBookingDetailMutation,
} from '../store/api/bookingsApi';
import toast from 'react-hot-toast';
import { fDateTimeSuffix } from '../utils/formatTime';


import { format } from 'date-fns';
const SORT_OPTIONS = [
  { value: 'latest', label: 'Latest' },
  { value: 'popular', label: 'Popular' },
  { value: 'oldest', label: 'Oldest' },
];

let day1 = new Date();

let day7 = moment().startOf('week').toDate();
let day30 = moment().endOf('week').toDate();
day30 = day30.toISOString();
let newDay = [day1, day7, day30];

const loginDetails = JSON.parse(localStorage.getItem('login') || '{}');
const userType = loginDetails.userType;
const loggedInServiceProviderId = loginDetails.serviceProviderId;

export default function ViewBooking() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { state } = useLocation();
  const [updateState, setUpdateState] = useState({});
  const [revenues, setRevenues] = useState([]);
  const token = JSON.parse(localStorage.getItem('login') || '{}').token;
  const [getRevenueData, revenueResponse] = useGetRevenueDataMutation();
  const [findMiscellaneousChargeById, findMiscellaneousChargeByIdResponse] = useFindMiscellaneousChargeByIdMutation();
  const [findMiscellaneousChargesByBookingId, findMiscellaneousChargesByBookingIdResponse] = useFindMiscellaneousChargesByBookingIdMutation();
  const [saveMiscellaneousCharge, saveMiscellaneousChargeResponse] = useSaveMiscellaneousChargeMutation();
  const [findMiscellaneousChargesByLabourId, findMiscellaneousChargesByLabourIdResponse] = useFindMiscellaneousChargesByLabourIdMutation();
  const [getMiscellaneousByLabourAndBooking, getMiscellaneousByLabourAndBookingResponse] = useGetMiscellaneousByLabourAndBookingMutation();
  const [updateMiscellaneousCharge, updateMiscellaneousChargeResponse] = useUpdateMiscellaneousChargeMutation();
  const [deleteMiscellaneousCharge, deleteMiscellaneousChargeResponse] = useDeleteMiscellaneousChargeMutation();
  const [calculateExtraBilling, calculateExtraBillingResponse] = useCalculateExtraBillingMutation();
  const [completeBookingDetail, completeBookingDetailResponse] = useCompleteBookingDetailMutation();
  const [bookingSpaces, setbookingSpaces] = useState([]);
  const [openAddMiscellaneousModal, setOpenAddMiscellaneousModal] = useState(false);
  const [selectedLabourId, setSelectedLabourId] = useState() as any;
  const [selectedBookingId, setSelectedBookingId] = useState() as any;
  const [selectedChargeId, setSelectedChargeId] = useState() as any;
  const [editMode, setEditMode] = useState(false);
  const role = useAppSelector(getAuthDetails);

  useEffect(() => {
    setbookingSpaces(state);
    console.log("Booking Spaces", state);
  }, [state]);

  const [expanded, setExpanded] = useState<{ [key: string]: boolean }>({
    panel1: true,
    panel2: true,
    panel3: true,
    panel4: true,
    panel6: true,
  });

  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(prevState => ({
      ...prevState,
      [panel]: isExpanded,
    }));
  };

  const [formValues, setFormValues] = useState({
    chargeName: '',
    chargeDescription: '',
    amount: '',
  });


  const [miscellaneousCharges, setMiscellaneousCharges] = useState([]);

  const styleActiveModel = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '40px',
    px: '30px',
  };

  const addMiscellaneousChargeToBooking = (bookingId, labourId) => {

    setEditMode(false);
    setOpenAddMiscellaneousModal(true);
    setSelectedBookingId(bookingId);
    setSelectedLabourId(labourId);
    console.log("Booking Save Id:", bookingId);
    console.log("Labour Save Id:", labourId);
  };

  const handleCloseAddMiscellaneousModal = () => {
    setOpenAddMiscellaneousModal(false);
  };

  const handleSubmitForm = (values, { resetForm }) => {
    console.log("Booking id in submit:", selectedBookingId);
    console.log("Labour id in submit:", selectedLabourId);
    if (editMode) {
      updateMiscellaneousCharge({
        token: token,
        payload: {
          labourId: selectedLabourId,
          bookingId: selectedBookingId,
          id: selectedChargeId,
          amount: values.amount,
          description: values.chargeDescription,
          chargeName: values.chargeName,
        }
      });
    } else {
      saveMiscellaneousCharge({
        token: token,
        payload: {
          labourId: selectedLabourId,
          bookingId: selectedBookingId,
          amount: values.amount,
          description: values.chargeDescription,
          chargeName: values.chargeName,
        }
      });
    }
    resetForm();
    handleCloseAddMiscellaneousModal();
  };

  const bookingSpaceId = state?.id;
  useEffect(() => {
    if (bookingSpaceId) {
      findMiscellaneousChargesByBookingId({
        token: token,
        bookingId: bookingSpaceId,
      });
    }
  }, [bookingSpaceId]);

  useEffect(() => {
    if (findMiscellaneousChargesByBookingIdResponse.isSuccess) {
      setMiscellaneousCharges(findMiscellaneousChargesByBookingIdResponse.data || []);
    }
  }, [findMiscellaneousChargesByBookingIdResponse.isSuccess]);

  const updateMiscellaneousChargeToBooking = (id, bookingId, labourId) => {

    console.log("Booking UpdateId:", bookingId);
    console.log("Labour Update Id:", labourId);

    setEditMode(true);
    setSelectedBookingId(bookingId);
    setSelectedLabourId(labourId);
    setSelectedChargeId(id);
    setOpenAddMiscellaneousModal(true);
    console.log("Miscellaneous Id:", id);
    findMiscellaneousChargeById({
      token: token,
      id: selectedChargeId,
    });
  };

  useEffect(() => {
    if (editMode) {
      if (findMiscellaneousChargeByIdResponse.isSuccess) {
        console.log("findMiscellaneousChargeByIdResponse", findMiscellaneousChargeByIdResponse.data);
        setFormValues((prevState) => ({
          ...prevState,
          chargeName: findMiscellaneousChargeByIdResponse.data?.chargeName || '',
          chargeDescription: findMiscellaneousChargeByIdResponse.data?.description || '',
          amount: findMiscellaneousChargeByIdResponse.data?.amount || '',
        }));
      }
    } else {
      setFormValues({
        chargeName: '',
        chargeDescription: '',
        amount: '',
      });
    }
  }, [findMiscellaneousChargeByIdResponse.isSuccess, editMode]);

  const deleteMiscellaneousChargeFromBooking = (id) => {

    console.log("Delete Id:", id);
    deleteMiscellaneousCharge({
      token: token,
      id: id,
    });
  };


  useEffect(() => {
    if ((deleteMiscellaneousChargeResponse.isSuccess || saveMiscellaneousChargeResponse.isSuccess || updateMiscellaneousChargeResponse.isSuccess) && bookingSpaceId) {
      findMiscellaneousChargesByBookingId({
        token: token,
        bookingId: bookingSpaceId,
      });
    }
  }, [saveMiscellaneousChargeResponse.isSuccess, deleteMiscellaneousChargeResponse.isSuccess, updateMiscellaneousChargeResponse.isSuccess, bookingSpaceId, token]);

  const maskEmail = (email) => {
    if (!email) return '';
    const [local, domain] = email.split('@');
    if (local.length > 3) {
      return local.slice(0, 3) + '****' + '@' + domain;
    }
    return email;
  };

  const maskPhone = (phone) => {
    if (!phone) return '';
    return '****' + phone.slice(-4);
  };

  const [billingData, setBillingData] = useState(null);
  const [openChargesModal, setOpenChargesModal] = useState(false);

  const formatDateTime = (isoString) => {
    if (!isoString) {
      return '';
    }
    const date = new Date(isoString);
    if (isNaN(date.getTime())) {
      return '';
    }
    const formattedDate = date.toISOString().slice(0, 19).replace('T', ' ');
    return formattedDate;
  };

  const handleOpenModal = () => {
    setOpenChargesModal(true);
    calculateExtraBilling({
      token: token,
      payload: {
        bookingId: bookingSpaces?.id,
        checkInTime: formatDateTime(bookingSpaces?.checkinTime),
        checkOutTime: formatDateTime(bookingSpaces?.checkoutTime),
        customerId: bookingSpaces?.customerDetailResponseDTO?.id,
        fromLat: bookingSpaces?.fromLatitude,
        fromLng: bookingSpaces?.fromLongitude,
        isCommercial: "string",
        offerId: bookingSpaces?.offerDetailId,
        parkingCategoryId: bookingSpaces?.parkingCategoryId,
        parkingSpaceLocationId: bookingSpaces?.parkingSpaceLocationRespDTO?.id,
        parkingType: bookingSpaces?.parkingTypeObj?.typeName,
        toLat: bookingSpaces?.toLatitude,
        toLng: bookingSpaces?.toLongitude,
      },
    });
  };

  useEffect(() => {
    if (calculateExtraBillingResponse.isSuccess) {
      setBillingData(calculateExtraBillingResponse.data || []);
    }
  }, [calculateExtraBillingResponse.isSuccess]);

  const handleCloseModal = () => {
    setOpenChargesModal(false);
    setBillingData(null);
  };

  const handleCompleteBooking = (billingData) => {
    console.log("Paid By", bookingSpaces?.paidBy);
    completeBookingDetail({
      token: token,
      payload: {
        actualCheckoutTime: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
        bookingId: bookingSpaces?.id,
        countyTaxAmount: billingData?.countyTaxAmount,
        extraAmount: billingData?.extraAmount,
        paidBy: bookingSpaces?.paidBy,
        pendingAmount: billingData?.pendingAmount,
        salesTaxAmount: billingData?.salesTaxAmount,
        stateTaxAmount: billingData?.stateTaxAmount,
        transactionId: bookingSpaces?.transactionRefId || "12_transaction_test",
      },
    });
    setOpenChargesModal(false);
  };


  useEffect(() => {
    if (completeBookingDetailResponse.isSuccess) {
      toast.success('Booking completed successfully'); 
      navigate('/dashboard/bookings', { replace: true });
    } else if (completeBookingDetailResponse.isError) {
      const errorData: any = completeBookingDetailResponse.error;
      const msg: string = errorData?.data?.serviceErrors?.[0]?.msg || '';
      toast.error(`Something went wrong${msg ? ': ' + msg : ''}`); 
    }
  }, [
    completeBookingDetailResponse.isSuccess,
    completeBookingDetailResponse.isError,
  ]);


  const totalMiscellaneousCharges = miscellaneousCharges?.reduce(
    (sum, charge) => sum + (charge.amount || 0),
    0
  ) || 0;

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
        <Typography variant="h4" sx={{ flexGrow: 1 }}>Booking Details</Typography>
        {bookingSpaces?.bookingStatus !== 'Completed' && (
          <Button
            variant="contained"
            sx={{ backgroundColor: '#E23744', color: 'white', '&:hover': { backgroundColor: '#E23744' } }}
            onClick={() => {
              handleOpenModal()
            }}
            disabled={bookingSpaces?.bookingStatus !== 'in_transit'}

          >
            Complete Booking
          </Button>
        )}
        {bookingSpaces?.bookingStatus === 'Completed' && (
          <Typography variant="h6" gutterBottom color="green">
            Completed
          </Typography>
        )}
        <Button
          variant="contained"
          sx={{ backgroundColor: '#E23744', color: 'white', ml: 2, '&:hover': { backgroundColor: '#E23744' } }}
          onClick={() => {
            if (userType === 'UTSA') {
              navigate('/dashboard/all-bookings', {
                replace: true,
                state: {
                  flag: bookingSpaces?.getFlag,
                },
              });
            } else if (userType === 'UTSP' || userType === 'UTLB') {
              console.log("Back Flag", bookingSpaces?.getFlag);
              navigate('/dashboard/bookings', {
                replace: true,
                state: {
                  labourFlag: bookingSpaces?.labourFlag,
                  getFlag: bookingSpaces?.getFlag,
                },
              });
            }
          }}
          startIcon={<ArrowBackIcon />}
        >
          Back
        </Button>
      </Stack>

      <Grid container spacing={2}>
        {/* Customer Details and Booking Details */}
        <Grid item xs={12} md={3}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent
              sx={{
                flexGrow: 1,
                overflowY: 'auto',
                overflowX: 'hidden',
                height: '450px',
                padding: '3px',
                paddingTop: '5px',
              }}
            >
              {/* Customer Detail Accordion */}
              <Accordion
                expanded={expanded.panel1}
                onChange={handleChange('panel1')}
                sx={{
                  border: '1px solid #ccc',
                  boxShadow: 'none',
                  '&:not(:last-child)': {
                    marginBottom: '8px',
                  },
                }}
              >
                <AccordionSummary sx={{ padding: '0px 5px', backgroundColor: expanded.panel1 ? '#f2f2f2' : 'transparent', }} expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" gutterBottom>
                    Customer Detail
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: ' 3px 5px 5px' }}>
                  <Typography sx={{ mb: 2, display: 'flex', alignItems: 'center' }} variant="body2">
                    <PersonIcon sx={{ marginRight: 1 }} />{capitalName(bookingSpaces?.customerDetailResponseDTO?.name)}
                  </Typography>
                  <Typography sx={{
                    mb: 2,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    display: 'flex', alignItems: 'center',
                  }} variant="body2">
                    <EmailIcon sx={{ marginRight: 1 }} /> {userType === 'UTLB' ? maskEmail(bookingSpaces?.customerDetailResponseDTO?.email) : bookingSpaces?.customerDetailResponseDTO?.email}
                  </Typography>
                  <Typography sx={{ mb: 2, display: 'flex', alignItems: 'center' }} variant="body2">
                    <PhoneIcon sx={{ marginRight: 1 }} />
                    {userType === 'UTLB' ? maskPhone(bookingSpaces?.customerDetailResponseDTO?.phoneNo) : bookingSpaces?.customerDetailResponseDTO?.phoneNo}
                  </Typography>

                  <Typography sx={{ mb: 2, display: 'flex', alignItems: 'center' }} variant="body2">
                    <HomeIcon sx={{ marginRight: 1 }} />
                    {bookingSpaces?.customerDetailResponseDTO?.city},{' '}
                    {bookingSpaces?.customerDetailResponseDTO?.state}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Booking Detail Accordion */}
              <Accordion
                expanded={expanded.panel2}
                onChange={handleChange('panel2')}
                sx={{
                  border: '1px solid #ccc',
                  boxShadow: 'none',
                  '&:not(:last-child)': {
                    marginBottom: '8px',
                  },
                }}
              >
                <AccordionSummary sx={{ padding: '0px 5px', backgroundColor: expanded.panel2 ? '#f2f2f2' : 'transparent', }} expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" gutterBottom>
                    Booking Detail
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: ' 3px 5px 5px' }}>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Booking ID:</strong> {bookingSpaces?.bookingCode}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Booking Date:</strong>{' '}
                     {bookingSpaces?.bookingDate ?fDateTimeSuffix(bookingSpaces?.bookingDate):""}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Status:</strong> {capitalName(bookingSpaces?.bookingStatus)}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Pickup Address:</strong> {bookingSpaces?.fromLocation}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Dropoff Address:</strong> {bookingSpaces?.toLocation}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Pickup Date:</strong>{' '}
                    {bookingSpaces?.bookingDate ?fDateTimeSuffix(bookingSpaces?.checkinTime):""}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Dropoff Date:</strong>{' '}
                    {bookingSpaces?.bookingDate ?fDateTimeSuffix(bookingSpaces?.checkoutTime):""}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Payment Method:</strong> {bookingSpaces?.paymentMethodName}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Transaction ID:</strong> {bookingSpaces?.transactionRefId || 'N/A'}
                  </Typography>
                </AccordionDetails>
              </Accordion>

            </CardContent>
          </Card>
        </Grid>

        {/* Driver Detail and Vehicle Detail*/}
        <Grid item xs={12} md={3}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent
              sx={{
                flexGrow: 1,
                overflowY: 'auto',
                overflowX: 'hidden',
                height: '450px',
                padding: '3px',
                paddingTop: '5px',
              }}
            >
              {/* Driver Detail Accordion */}
              {userType !== 'UTLB' && (
                <Accordion
                  expanded={expanded.panel3}
                  onChange={handleChange('panel3')}
                  sx={{
                    border: '1px solid #ccc',
                    boxShadow: 'none',
                    '&:not(:last-child)': {
                      marginBottom: '8px',
                    },
                  }}
                >
                  <AccordionSummary
                    sx={{
                      padding: '0px 5px',
                      backgroundColor: expanded.panel3 ? '#f2f2f2' : 'transparent',
                    }}
                    expandIcon={<ExpandMoreIcon />}
                  >
                    <Typography variant="h6" gutterBottom>
                      Driver Detail
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: '3px 5px 5px' }}>
                    {
                      (() => {
                        const status = bookingSpaces?.bookingLabourMappingObj?.[0]?.status;

                        if (status === 'LABOUR_ACCEPTED') {
                          return (
                            <>
                              <Typography sx={{ mb: 2, display: 'flex', alignItems: 'center' }} variant="body2">
                                <PersonIcon sx={{ marginRight: 1 }} />
                                {capitalName(bookingSpaces?.bookingLabourMappingObj?.[0]?.labourDetail?.fullName)}
                              </Typography>
                              <Typography sx={{ mb: 2, display: 'flex', alignItems: 'center' }} variant="body2">
                                <EmailIcon sx={{ marginRight: 1 }} />
                                {bookingSpaces?.bookingLabourMappingObj?.[0]?.labourDetail?.emailId}
                              </Typography>
                              <Typography sx={{ mb: 2, display: 'flex', alignItems: 'center' }} variant="body2">
                                <PhoneIcon sx={{ marginRight: 1 }} />
                                {bookingSpaces?.bookingLabourMappingObj?.[0]?.labourDetail?.registeredPhoneNumber}
                              </Typography>
                            </>
                          );
                        } else if (status === 'REQUEST_LABOUR') {
                          return (
                            <Typography sx={{ color: 'blue', fontStyle: 'italic' }} variant="body2">
                              Driver Requested
                            </Typography>
                          );
                        } else if (status === 'LABOUR_REJECTED') {
                          return (
                            <Typography sx={{ color: 'red', fontStyle: 'italic' }} variant="body2">
                              Driver Rejected
                            </Typography>
                          );
                        } else {
                          return (
                            <Typography sx={{ color: 'red', fontStyle: 'italic' }} variant="body2">
                              Please Assign a Driver
                            </Typography>
                          );
                        }
                      })()
                    }
                  </AccordionDetails>
                </Accordion>

              )}

              {/* Vehicle Detail Accordion */}
              <Accordion
                expanded={expanded.panel4}
                onChange={handleChange('panel4')}
                sx={{
                  border: '1px solid #ccc',
                  boxShadow: 'none',
                  '&:not(:last-child)': {
                    marginBottom: '8px',
                  },
                }}
              >
                <AccordionSummary
                  sx={{
                    padding: '0px 5px',
                    backgroundColor: expanded.panel4 ? '#f2f2f2' : 'transparent',
                  }}
                  expandIcon={<ExpandMoreIcon />}
                >
                  <Typography variant="h6" gutterBottom>
                    Vehicle Detail
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '3px 5px 5px' }}>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Vehicle Number:</strong> {bookingSpaces?.parkingSpaceLocationRespDTO?.vehicleDetailObj?.chassisNumber}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Model:</strong> {bookingSpaces?.parkingSpaceLocationRespDTO?.vehicleDetailObj?.model}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Type:</strong> {bookingSpaces?.parkingSpaceLocationRespDTO?.vehicleDetailObj?.type}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Registration Number:</strong> {bookingSpaces?.parkingSpaceLocationRespDTO?.vehicleDetailObj?.registrationNumber}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Fuel Type:</strong> {bookingSpaces?.parkingSpaceLocationRespDTO?.vehicleDetailObj?.fuelType}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Seats:</strong> {bookingSpaces?.parkingSpaceLocationRespDTO?.vehicleDetailObj?.seatingCapacity}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Color:</strong> {bookingSpaces?.parkingSpaceLocationRespDTO?.vehicleDetailObj?.color}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="body2">
                    <strong>Insurance Expiry Date:</strong> {formatDateTime(bookingSpaces?.parkingSpaceLocationRespDTO?.vehicleDetailObj?.insuranceExpiryDate, 'MM/DD/yyyy')}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Driver Status Buttons 
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Shortlist Driver
          </Typography>
          <Box>
            <Button fullWidth sx={{ mb: 1 }} variant="contained">
              Driver on Trial
            </Button>
            <Button fullWidth sx={{ mb: 1 }} variant="contained">
              Confirm Driver
            </Button>
            <Button fullWidth variant="contained">
              Rejected Driver
            </Button>
          </Box>
        </CardContent>
      </Card> */}
            </CardContent>
          </Card>
        </Grid>

        {/* Micellaneous  and Payment Detail*/}
        <Grid item xs={12} md={3}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent
              sx={{
                flexGrow: 1,
                overflowY: 'auto',
                overflowX: 'hidden',
                height: '450px',
                padding: '3px',
                paddingTop: '5px',
              }}
            >

              {/* Miscellaneous Charges Accordion */}
              <Accordion
                expanded={expanded.panel6}
                onChange={handleChange('panel6')}
                sx={{
                  border: '1px solid #ccc',
                  boxShadow: 'none',
                  '&:not(:last-child)': {
                    marginBottom: '8px',
                  },
                }}
              >
                <AccordionSummary
                  sx={{
                    padding: '0px 5px',
                    backgroundColor: expanded.panel6 ? '#f2f2f2' : 'transparent',
                  }}
                  expandIcon={<ExpandMoreIcon />}
                >
                  <Typography variant="h6" gutterBottom>
                    Miscellaneous
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '3px 5px 5px' }}>
                  {/* Render Miscellaneous Charge Cards */}
                  {miscellaneousCharges?.map((charge, index) => (
                    <Card key={index} sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                      <CardContent
                        sx={{
                          flex: 1,
                          padding: '4px 8px',
                          paddingBottom: '4px !important',
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="h6" gutterBottom>
                            {charge.chargeName}
                          </Typography>
                          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            {charge.description}
                          </Typography>
                          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            {charge.amount}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            marginLeft: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                          }}
                        >
                          <IconButton
                            color="primary"
                            size="small"
                            onClick={() =>
                              updateMiscellaneousChargeToBooking(
                                charge.id,
                                bookingSpaces?.id,
                                bookingSpaces?.bookingLabourMappingObj?.[0]?.labourDetail?.id
                              )
                            }
                            sx={{ mb: 1 }} /* Adds margin between the buttons */
                          >
                            <EditIcon />
                          </IconButton>
                          {/** <IconButton
                  color="primary"
                  size="small"
                  onClick={() => deleteMiscellaneousChargeFromBooking(charge.id)}
                >
                  <DeleteIcon />
                </IconButton> */}
                        </Box>
                      </CardContent>
                    </Card>
                  ))}

                  {/* Add Miscellaneous Charge Card */}
                  <Card sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                    <CardContent
                      sx={{
                        flex: 1,
                        padding: '4px 8px',
                        paddingBottom: '4px !important',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="body2">Add Miscellaneous Charge</Typography>
                      </Box>
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => {
                          addMiscellaneousChargeToBooking(
                            bookingSpaces?.id,
                            bookingSpaces?.bookingLabourMappingObj?.[0]?.labourDetail?.id
                          )
                        }}
                        sx={{ marginLeft: 'auto' }}
                      >
                        <AddIcon />
                      </IconButton>
                    </CardContent>
                  </Card>
                </AccordionDetails>
              </Accordion>

              {/* Payment Detail Accordion */}
              <Accordion
                expanded={expanded.panel5}
                onChange={handleChange('panel5')}
                sx={{
                  border: '1px solid #ccc',
                  boxShadow: 'none',
                  '&:not(:last-child)': {
                    marginBottom: '8px',
                  },
                }}
              >
                <AccordionSummary sx={{ padding: '0px 5px', backgroundColor: expanded.panel5 ? '#f2f2f2' : 'transparent', }} expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" gutterBottom>
                    Payment Detail
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: ' 3px 5px 5px' }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, borderBottom: '2px solid' }}>
                    <Typography variant="body2">
                      <strong>Paid by {bookingSpaces?.paymentMethodName}</strong>
                    </Typography>
                  </Box>

                  {/* Vehicle Charges */}
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="body2">
                      <strong>Vehicle Charges:</strong>
                    </Typography>
                    <Typography variant="body2">
                      ₹{(bookingSpaces?.totalAmount - (bookingSpaces?.tollCharges || 0)).toFixed(2)}
                    </Typography>
                  </Box>

                  {miscellaneousCharges?.length > 0 && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                      <Typography variant="body2">
                        <strong>Extra Charges:</strong>
                      </Typography>
                      <Typography variant="body2">
                        ₹{totalMiscellaneousCharges.toFixed(2)}
                      </Typography>
                    </Box>
                  )}


                  {/* Discount */}
                  {bookingSpaces?.discount > 0 && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                      <Typography variant="body2">
                        <strong>Discount:</strong> ₹
                        {bookingSpaces?.discountType === '%'
                          ? `${bookingSpaces?.discount}${bookingSpaces?.discountType}`
                          : ''}
                      </Typography>
                      <Typography variant="body2">
                        -₹{getAmount(bookingSpaces?.discountType, bookingSpaces?.totalAmount, bookingSpaces?.discount)}
                      </Typography>
                    </Box>
                  )}

                  {/* Offer Discount */}
                  {bookingSpaces?.offerDiscount > 0 && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                      <Typography variant="body2">
                        <strong>Offer Discount:</strong>
                      </Typography>
                      <Typography variant="body2">
                        -₹{bookingSpaces?.offerDiscount?.toFixed(2)}
                      </Typography>
                    </Box>
                  )}

                  {/* Finder Bucks */}
                  {bookingSpaces?.redeemAmount > 0 && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                      <Typography variant="body2">
                        <strong>Finder Bucks:</strong>
                      </Typography>
                      <Typography variant="body2">
                        ₹{bookingSpaces?.redeemAmount?.toFixed(2)}
                      </Typography>
                    </Box>
                  )}

                  {/* Toll Charges */}
                  {bookingSpaces?.tollCharges > 0 && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                      <Typography variant="body2">
                        <strong>Toll Charges:</strong>
                      </Typography>
                      <Typography variant="body2">
                        ₹{bookingSpaces?.tollCharges?.toFixed(2)}
                      </Typography>
                    </Box>
                  )}

                  {/* Grand Total */}
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="body2">
                      <strong>Grand Total:</strong>
                    </Typography>
                    <Typography variant="body2">
                      ₹{bookingSpaces?.totalAmount?.toFixed(2)}
                    </Typography>
                  </Box>
                </AccordionDetails>
              </Accordion>

            </CardContent>
          </Card>
        </Grid>

        {/* Booking Progress */}
        {/* <Grid item xs={12} md={3}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>Progress</Typography>
            <List>
              {bookingSpaces?.progress?.map((step, index) => (
                <ListItem key={index} sx={{ borderBottom: '1px solid #ddd' }}>
                  <ListItemText
                    primary={step.title}
                    secondary={formatDateTime(step.date, 'MM/DD/yyyy, hh:mm A')}
                  />
                </ListItem>
              ))}
            </List>
          </CardContent>
        </Card>
      </Grid> */}
      </Grid>

      {findMiscellaneousChargesByBookingIdResponse.isLoading || completeBookingDetailResponse.isLoading ||
        findMiscellaneousChargeByIdResponse.isLoading ? (
        <Loading />
      ) : null}

      <Modal
        open={openAddMiscellaneousModal}
        onClose={handleCloseAddMiscellaneousModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ alignItems: 'center', marginTop: '10%' }}
      >
        <Box
          sx={{
            ...styleActiveModel,
            overflowY: 'auto',
            height: { xs: 'auto', sm: '70%', md: '60%' },
            width: { xs: '90%', sm: '70%', md: '30%' },
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h5" gutterBottom>
              {editMode ? 'Edit New Miscellaneous Charge' : 'Add New Miscellaneous Charge'}
            </Typography>
            <Button
              variant="contained"
              color="error"
              onClick={handleCloseAddMiscellaneousModal}
              size="medium"
            >
              <ClearIcon />
            </Button>
          </Stack>
          <Formik
            enableReinitialize
            initialValues={formValues}
            onSubmit={handleSubmitForm}
            validate={(values) => {
              const errors = {};
              if (!values.chargeName) errors.chargeName = 'Miscellaneous charge name is required';
              if (!values.chargeDescription) errors.chargeDescription = 'Description is required';
              if (!values.amount) errors.amount = 'Amount is required';
              return errors;
            }}
          >
            {({ handleBlur, handleChange, handleSubmit, setFieldValue, values, touched, errors }) => (
              <Box style={{ width: '100%' }}>
                <Box style={{ width: '100%', marginBottom: '20px' }}>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      id="chargeName"
                      label="Charge Name"
                      placeholder="Enter Miscellaneous Charge name"
                      value={values.chargeName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="chargeName"
                    />
                    {errors.chargeName && <div style={{ color: "red" }}>{errors.chargeName}</div>}
                  </FormControl>
                </Box>
                <Box style={{ width: '100%', marginBottom: '20px' }}>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      id="chargeDescription"
                      label="Charge Description"
                      placeholder="Enter Description"
                      value={values.chargeDescription}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="chargeDescription"
                    />
                    {errors.chargeDescription && <div style={{ color: "red" }}>{errors.chargeDescription}</div>}
                  </FormControl>
                </Box>
                <Box style={{ width: '100%' }}>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      id="amount"
                      label="Amount"
                      placeholder="Enter Amount"
                      value={values.amount}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="amount"
                    />
                    {errors.amount && <div style={{ color: "red" }}>{errors.amount}</div>}
                  </FormControl>
                </Box>
                <Box style={{ width: '100%', display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                  <Button
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                    variant="contained"
                    size="large"
                    component="span"
                    onClick={handleSubmit}
                  >
                    {editMode ? 'Update' : 'Add'}
                  </Button>
                </Box>
              </Box>
            )}
          </Formik>
        </Box>
      </Modal>

      <Modal
        open={openChargesModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ alignItems: "center", marginTop: "10%" }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: 24,
            width: { xs: "90%", sm: "70%", md: "30%" },
            margin: "auto",
            overflowY: "auto",
            maxHeight: "70vh",
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h5">Billing Details</Typography>
            <Button variant="contained" style={{ color: 'white', backgroundColor: '#E23744' }} onClick={handleCloseModal} size="medium">
              <ClearIcon />
            </Button>
          </Stack>

          {billingData ? (
            <Box mt={2}>
              <Stack spacing={1.5}>
                <Typography><strong>Paid Amount:</strong> ₹{billingData?.paidAmount != null ? billingData?.paidAmount.toFixed(2) : 'N/A'}</Typography>
                <Typography><strong>Pending Amount:</strong> ₹{billingData?.pendingAmount != null ? billingData?.pendingAmount.toFixed(2) : 'N/A'}</Typography>
                <Typography><strong>Extra Amount:</strong> ₹{billingData?.extraAmount != null ? billingData?.extraAmount.toFixed(2) : 'N/A'}</Typography>
                <Typography><strong>Sales Tax:</strong> ₹{billingData?.salesTaxAmount != null ? billingData?.salesTaxAmount.toFixed(2) : 'N/A'}</Typography>
                <Typography><strong>County Tax:</strong>₹{billingData?.countyTaxAmount != null ? billingData?.countyTaxAmount.toFixed(2) : 'N/A'}</Typography>
                <Typography><strong>State Tax:</strong>₹{billingData?.stateTaxAmount != null ? billingData?.stateTaxAmount.toFixed(2) : 'N/A'}</Typography>


              </Stack>

              <Box display="flex" justifyContent="flex-end" mt={2}>
                <Button
                  style={{ color: 'white', backgroundColor: '#E23744' }}
                  variant="contained"
                  size="large"
                  component="span"
                  onClick={() => {
                    handleCompleteBooking(billingData)
                  }}
                >
                  COMPLETE
                </Button>
              </Box>
            </Box>
          ) : (
            <Typography mt={2}>Loading billing details...</Typography>
          )}
        </Box>
      </Modal>
    </Container>

  );
}
